module.exports = __webpack_public_path__ + "static/media/meal-food.a44f6048.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/meal-food.jpg
// module id = 474
// module chunks = 0